import { FC, ReactNode } from 'react'

import { Box, BoxProps } from '@mui/material'

import './NewsCardRibbon.scss'

type NewsCardRibbonProps = BoxProps & {
  children?: ReactNode
  backgroundColor?: string
  textColor?: string
}

export const NewsCardRibbon: FC<NewsCardRibbonProps> = ({ children, backgroundColor, textColor, ...boxProps }) => {
  return (
    <Box
      className="NewsCardRibbon"
      sx={{
        fontSize: 13,
        ...(backgroundColor && { backgroundColor: `${backgroundColor} !important` }),
        ...(textColor && { color: `${textColor} !important` }),
        ...boxProps.sx,
      }}
      {...boxProps}
    >
      {children}
    </Box>
  )
}
